<template>
    <div class="card onmaum-w-100">
        <div class="card-header">
            동물병원 관리
        </div>
        <div class="card-body">
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col-md-12">
                            <h6><i class="fas fa-hospital-alt text-dark text-sm opacity-10"></i> 동물병원 관리</h6>
                        </div>
                        <div class="col-md-12">
                            <div class="onmaum-alert onmaum-alert-alarm" role="alert">
                                <ul>
                                    <li>위치 좌표값 구하는 방법 ~~~~</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0 onmaum-h-50-v onmaum-overflow onmaum-overflow-type02">
                        <table class="table table-striped text-center table align-items-center mb-0" style="table-layout: fixed;">
                            <thead>
                                <tr>
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="5%" >ID</th>
                                    <!-- <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="5%" >Depth</th> -->
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="30%" >병원명/주소/전화번호</th>
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="15%" >위치</th>
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="30%" >진료정보</th>
                                    <!-- <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="5%" >정렬</th> -->
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="5%" >노출여부</th>
                                    <th class="text-secondary text-sm font-weight-bolder opacity-7" scope="col" width="15%" >기능</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(hospital, i) in hospitalInfoTemp" :key="i">
                                    <!-- ID -->
                                    <td class="align-middle text-center text-sm">
                                        <p class="text-sm font-weight-bold mb-0">{{ i + 1 }}</p>
                                    </td>
                                    <td class="align-middle text-center text-sm">
                                        <ul class="list-group">
                                            <li class="list-group-item">
                                                <div class="d-flex w-100 justify-content-between align-items-center">
                                                    <div class="me-2">병원명: </div>
                                                    <input class="form-control text-sm font-weight-bold mb-0" v-model="hospital.name" :disabled="isDisabled(i)" />
                                                </div>
                                            </li>
                                            <li class="list-group-item">
                                                <div class="d-flex w-100 justify-content-between align-items-center">
                                                    <div class="me-2">주소: </div>
                                                    <input class="form-control text-sm font-weight-bold mb-0" v-model="hospital.address" :disabled="isDisabled(i)" />
                                                </div>
                                            </li>
                                            <li class="list-group-item">
                                                <div class="d-flex w-100 justify-content-between align-items-center">
                                                    <div class="me-2">전화번호: </div>
                                                    <input class="form-control text-sm font-weight-bold mb-0" v-model="hospital.tel" :disabled="isDisabled(i)" />
                                                </div>
                                            </li>
                                        </ul>
                                    </td>
                                    <!-- 위치 -->
                                    <td class="align-middle text-center text-sm">
                                        <ul class="list-group">
                                            <li class="list-group-item">
                                                <div class="d-flex w-100 justify-content-between align-items-center">
                                                    <div class="me-2">X좌표: </div>
                                                    <input class="form-control text-sm font-weight-bold mb-0" v-model="hospital.position.x" :disabled="isDisabled(i)" />
                                                </div>
                                            </li>
                                            <li class="list-group-item">
                                                <div class="d-flex w-100 justify-content-between align-items-center">
                                                    <div class="me-2">Y좌표: </div>
                                                    <input class="form-control text-sm font-weight-bold mb-0" v-model="hospital.position.y" :disabled="isDisabled(i)" />
                                                </div>
                                            </li>
                                        </ul>
                                    </td>
                                    <!-- 진료정보 -->
                                    <td class="align-middle text-center text-sm">
                                        <ul class="list-group">
                                            <li class="list-group-item" v-for="(t, j) in hospital.time" :key="j">
                                                <input class="form-control text-sm font-weight-bold mb-0" v-model="hospital.time[j]" :disabled="isDisabled(i)" />
                                            </li>
                                            <li class="list-group-item pb-0" v-show="!isDisabled(i)">
                                                <button class="btn btn-outline-primary" @click="addTime(i)">+ 진료정보추가</button>
                                            </li>
                                        </ul>
                                    </td>
                                    <!-- 정렬 -->
                                    <!-- <td class="align-middle text-center text-sm">
                                        <input class="form-control text-sm font-weight-bold mb-0" v-model="hospital.sort" :disabled="isDisabled(i)" />
                                    </td> -->
                                    <!-- 노출여부 -->
                                    <td class="align-middle text-center text-sm">
                                        <div class="form-check form-switch d-inline-block ">
                                            <input class="form-check-input" type="checkbox" role="switch" :id="`isShow${i}`" :style="hospital.isShow?`background-color:#FF931E; border-color: #FF931E;`:''" v-model="hospital.isShow" :disabled="isDisabled(i)">
                                            <label class="form-check-label" :for="`isShow${i}`">
                                                <span class="badge onmaum-badge-default" v-if="hospital.isShow">노출</span>
                                                <span class="badge onmaum-badge-regist" v-if="!hospital.isShow">숨김</span>
                                            </label>
                                        </div>
                                    </td>
                                    <!-- 기능 -->
                                    <td class="align-middle text-center text-sm align-items-center">
                                        <button class="btn btn-link px-3 mb-0" @click="edit(i)" v-if="isDisabled(i)">
                                            <i class="fas fa-pencil-alt onmaum-text-contract me-2" aria-hidden="true"></i>편집
                                        </button>
                                        <button class="btn btn-link px-3 mb-0" @click="del(hospital._id, i)" v-if="isDisabled(i)">
                                            <i class="fas fa-trash-alt onmaum-text-red me-2" aria-hidden="true"></i>삭제
                                        </button>
                                        <button class="btn btn-link px-3 mb-0" @click="save(hospital, i)" v-if="!isDisabled(i)">
                                            <i class="fas fa-check-circle onmaum-text-success me-2" aria-hidden="true"></i>저장
                                        </button>
                                        <button class="btn btn-link px-3 mb-0" @click="cancel(i)" v-if="!isDisabled(i)">
                                            <i class="fas fa-times onmaum-text-black me-2" aria-hidden="true"></i>취소
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="row">
                            <div class="col-3">
                                <h6><i class="fas fa-hospital-alt text-dark text-sm opacity-10"></i> 신규 입력</h6>
                            </div>
                            <div class="col-6">

                            </div>
                            <div class="col-3">
                                <button class="btn btn-warning btn-sm ms-3 w-100" @click="insert()">입력</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-2">
                            <label for="hospitalInfoNewName" class="form-control-label fs-5">병원명</label>
                            <input id="hospitalInfoNewName" class="form-control invalid" type="text" v-model="hospitalInfoNew.name" placeholder="병원명"/>
                        </div>
                        <div class="col-2">
                            <label for="hospitalInfoNewAddress" class="form-control-label fs-5">주소</label>
                            <input id="hospitalInfoNewAddress" class="form-control invalid" type="text" v-model="hospitalInfoNew.address" placeholder="주소"/>
                        </div>
                        <div class="col-2">
                            <label for="hospitalInfoNewTel" class="form-control-label fs-5">전화번호</label>
                            <input id="hospitalInfoNewTel" class="form-control invalid" type="text" v-model="hospitalInfoNew.tel" placeholder="전화번호"/>
                        </div>
                        <div class="col-2">
                            <ul class="list-group">
                                <li class="list-group-item">
                                    <div class="d-flex w-100 justify-content-between align-items-center">
                                        <div class="me-2">X좌표: </div>
                                        <input class="form-control text-sm font-weight-bold mb-0" v-model="hospitalInfoNew.position.x" />
                                    </div>
                                </li>
                                <li class="list-group-item">
                                    <div class="d-flex w-100 justify-content-between align-items-center">
                                        <div class="me-2">Y좌표: </div>
                                        <input class="form-control text-sm font-weight-bold mb-0" v-model="hospitalInfoNew.position.y" />
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="col-3">
                            <ul class="list-group">
                                <li class="list-group-item" v-for="(t, j) in hospitalInfoNew.time" :key="j">
                                    <input class="form-control text-sm font-weight-bold mb-0" v-model="hospitalInfoNew.time[j]" />
                                </li>
                                <li class="list-group-item pb-0">
                                    <button class="btn btn-outline-primary" @click="addTimeNew(i)">+ 진료정보추가</button>
                                </li>
                            </ul>
                        </div>
                        <div class="col-1">
                            <label class="form-control-label fs-5">노출여부</label>
                            <div class="form-check form-switch d-inline-block ">
                                <input class="form-check-input" type="checkbox" role="switch" id="isShow" :style="hospitalInfoNew.isShow?`background-color:#5e72e4; border-color: #5e72e4;`:''" v-model="hospitalInfoNew.isShow" :disabled="isDisabled(i)">
                                <label class="form-check-label" for="isShow">
                                    <span class="badge bg-primary" v-if="hospitalInfoNew.isShow">사용</span>
                                    <span class="badge onmaum-badge-regist" v-if="!hospitalInfoNew.isShow">미사용</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'HospitalManage',
    data() {
        return {
            hospitalInfoTemp: [],
            disabled: [],
            hospitalInfoNew: {
                name: '',
                address: '',
                tel: '',
                position: {x: '0.0', y: '0.0'},
                time: [
                    `<span class="mr-5">진료항목</span>진료시간`,
                ],
                sort: 0,
                isShow: false,
            },
        }
    },

    methods:{
        edit(id) {
            this.disabled[id] = false;
            this.resetInfo();
        },

        async del(_id, id) {
            if(confirm('삭제하시겠습니까?')){
                await this.$store.dispatch('deleteHospitalInfo', {_id: _id});
                this.disabled.splice(id, 1);
                this.resetInfo();
            }
        },

        async save(list, id) {
            if(confirm('저장하시겠습니까?')){
                await this.$store.dispatch('modifyHospitalInfo', list);
                this.disabled[id] = true;
                this.resetInfo();
            }
        },

        cancel(id) {
            this.disabled[id] = true;
            this.resetInfo();
        },
        
        isDisabled(id) {
            return this.disabled[id];
        },

        addTime(id) {
            this.hospitalInfoTemp[id].time.push('<span class="mr-5">진료항목</span>진료시간');
        },

        addTimeNew() {
            this.hospitalInfoNew.time.push('<span class="mr-5">진료항목</span>진료시간');
        },

        async insert() {
            if(confirm('입력하시겠습니까?')){
                await this.$store.dispatch('insertHospitalInfo', this.hospitalInfoNew);
                this.disabled.push(true);
                this.resetInfo();
                this.resetTemp();
            }
        },

        resetInfo() {
            this.hospitalInfoTemp = JSON.parse(JSON.stringify(this.hospitalInfo));
        },

        resetTemp() {
            this.hospitalInfoNew = {
                name: '',
                address: '',
                tel: '',
                position: {x: 0.0, y: 0.0},
                time: [
                    `<span class="mr-5">진료항목</span>진료시간`,
                ],
                sort: 0,
                isShow: false,
            }
        },
    },

    computed: {
        hospitalInfo() {
            return this.$store.state.hondi.hospitalInfo;
        }
    },

    async mounted() {
        await this.$store.dispatch('getHospitalInfo');
        this.hospitalInfoTemp = JSON.parse(JSON.stringify(this.$store.state.hondi.hospitalInfo));
        this.disabled = Array.from({ length: this.$store.state.hondi.hospitalInfo.length }, () => true);
        this.resetInfo();
    },
}
</script>

<style>

</style>